import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import InputWithExtra from '../../Comman/components/InputWithExtra';
import { withNamespaces } from 'react-i18next';
import loader from '../../Comman/images/loader.gif'
import SimpleReactValidator from 'simple-react-validator';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import swal from 'sweetalert';
import { InputText } from 'primereact/inputtext';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

const sleep = (milliseconds) => {
    return new Promise(resolve => setTimeout(resolve, milliseconds))
}

var svValidator;
var engValidator;
var currentLang;

class PredefinedTextComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            Subject: '',
            RegionId:'',
            isEdit: false,
            subjectId: ''
        }
        this.handleInput = this.handleInput.bind(this);
        this.actionColumn = this.actionColumn.bind(this);

        if (sessionStorage.getItem('Language')) {
            currentLang = sessionStorage.getItem('Language');
        }
        else {
            currentLang = "en";
        }
    }
    componentWillReceiveProps(nextProps) {
        // console.log("next", nextProps);
        if (nextProps.predefinedTextData.message != this.props.predefinedTextData.message) {
            if (nextProps.predefinedTextData.statusCode == 200) {
                swal(nextProps.predefinedTextData.message, {
                    icon: "success",
                });
                this.props.getPredefinedTextData();
                this.setState({
                    Subject: '',
                    isEdit: false,
                    subjectId: ''
                })
            }
        }
        this.translateLang();
    }
    translateLang() {
        var language;
        if (sessionStorage.getItem('Language')) {
            language = sessionStorage.getItem('Language');
        }
        else {
            language = "en";
        }
        if (language == "en") {
            this.validator = engValidator;
        }
        else {
            this.validator = svValidator;
        }
    }
    componentWillMount() {
        SimpleReactValidator.addLocale('en', {
            required: 'The :attribute field is required.',
            min: 'The :attribute must be at least :min:type.'
        });
        SimpleReactValidator.addLocale('sv', {
            required: 'Fältet :attribute krävs.',
            min: ':attribute måste vara minst :min tecken.'
        });
        engValidator = new SimpleReactValidator(
            {
                locale: 'en'
            }
        );
        svValidator = new SimpleReactValidator(
            {
                locale: 'sv'
            }
        );
        this.validator = engValidator;
    }
    handleInput(e) {
        this.setState({
            Subject: e.target.value
        })
    }
    cancel(){
        this.setState({
            Subject: '',
            isEdit: false,
            subjectId: ''
        })
    }
    save() {
        if (this.validator.allValid()) {
            if (this.state.isEdit == true) {
                let data = {
                    "ID": this.state.subjectId,
                    "Description": this.state.Subject,
                   // "RegionId":this.state.RegionId
                    "RegionId": this.state.RegionId == '' ? (this.props.predefinedTextData.regionList.length > 0 ? this.props.predefinedTextData.regionList[0].ID : null) : this.state.RegionId,
                }
                this.props.updatePredefinedText(data);
            }
            else {
                debugger
                let payload = {
                    "Description": this.state.Subject,
                     "RegionId":this.state.RegionId,
                     "RegionId": this.state.RegionId == '' ? (this.props.predefinedTextData.regionList.length > 0 ? this.props.predefinedTextData.regionList[0].ID : null) : this.state.RegionId,
                }
                this.props.addPredefinedText(payload);
            }
        }
        else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }
    actionColumn(rowDatas) {
        const { t } = this.props;
        return (
            <span>
                <span onClick={() => { this.openModal(rowDatas) }} className="enable-cursor editicon" title={t('First_Responder.View')}>
                    <i className="fa fa-pencil" aria-hidden="true"></i></span>

                <span onClick={() => { this.delete(rowDatas) }} title={t('First_Responder.Delete')} className="enable-cursor">
                    <i className="fa fa-lg fa-trash" aria-hidden="true"></i>
                </span>
            </span>
        )

    }
    openModal(rowDatas) {
        this.setState({
            Subject: rowDatas.Description,
            isEdit: true,
            subjectId: rowDatas.ID
        })
    }
    delete(rowDatas) {
        const { t } = this.props;
        confirmAlert({
            title: `${t('First_Responder.Confirm to delete')}`,
            message: `${t('First_Responder.Are you sure to delete this?')}`,
            buttons: [
                {
                    label: `${t('First_Responder.Yes')}`,
                    onClick: () => {
                        let payload = {
                            ID: rowDatas.ID
                        }
                        this.props.deletePredefinedText(payload,this.state.RegionId == '' ? (this.props.predefinedTextData.regionList.length > 0 ? this.props.predefinedTextData.regionList[0].ID : null) : this.state.RegionId);
                    }
                },
                {
                    label: `${t('First_Responder.No')}`,
                    onClick: () => {
                    }
                }
            ]
        });
    }
    changeRegion = (e) => {
        let value = e.target.value;
        let payload = {
            RegionId: value,
        }
        this.state.RegionId = value.toString();
        this.setState({ RegionId: value.toString() });

        this.props.getUserList(payload)

        // sleep(3000).then(() => {
        //     console.log("setstate",this.state);
        // })
    }
    render() {
        const { t } = this.props;
          let  regionListOption;
           
          
      let regionList=this.props.predefinedTextData.regionList;
      if(regionList){
          regionListOption = regionList.map((item) =>
                <option style={{background : '#f5f1f1'}} value={item.ID} key={item.ID}>{item.RegionName}</option>
            );
            
        }
        var header = <div className="search-name">
            <i className="fa fa-search" style={{ margin: '4px 4px 0 0' }}></i>
            <InputText type="text" onInput={(e) => this.setState({ globalFilter: e.target.value })} placeholder={t('First_Responder.Search')} size="50" />
        </div>;
        return (
            <div>
                <div className="progressbar-heading grids-heading">
                    <h2>{t('Alarm Setting.Predefined Text For Description')}</h2>
                </div>
                <div className="panel panel-widget forms-panel w3-last-form setting-layout">
                    <div className="text-left m-b-25 ">


                                    <select id="regionData" style={{ fontSize: 'large', padding: '7px' }}
                                        onChange={this.changeRegion}
                                        placeholder="Select"
                                        ref="regionData"
                                        name={'RegionId'}
                                    >
                                        {regionListOption}
                                    </select>
                                </div><br></br>
                    <div className=" forms add-device setting-panel">
                        <div className="form-three widget-shadow">
                            <div className=" panel-body-inputin">
                                <form>
                                    <div className="form-group">
                                        <div className="row">
                                            <div className="col-md-2 radio-label">
                                                <label htmlFor="predefinedText" className="form-label">{t('Alarm Setting.Predefined Text')}</label>
                                            </div>
                                            <div className="col-md-9">
                                                <InputWithExtra
                                                    type={'text'}
                                                    title={t('Alarm Setting.Predefined Text')}
                                                    name={'PredefinedText'}
                                                    value={this.state.Subject}
                                                    placeholder={t('Alarm Setting.Predefined Text')}
                                                    onChange={this.handleInput}
                                                />
                                                {this.validator.message(`${t('Alarm Setting.Predefined Text')}`, this.state.Subject, 'required|min:2')}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="col-sm-offset-5 col-sm-6">
                                            <p className='butn-center'>
                                                {this.state.isEdit == true ?
                                                    <div>
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary general-btn"
                                                            onClick={() => { this.save() }}
                                                            disabled={this.props.predefinedTextData.isLoading == true}
                                                        >
                                                            {t('Email Setting.Update')}
                                                        </button> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary general-btn"
                                                            onClick={() => { this.cancel() }}
                                                            disabled={this.props.predefinedTextData.isLoading == true}
                                                        >
                                                            {t('Email Setting.Cancel')}
                                                        </button>
                                                    </div>
                                                    :
                                                    <button
                                                        type="button"
                                                        className="btn btn-primary general-btn"
                                                        onClick={() => { this.save() }}
                                                        disabled={this.props.predefinedTextData.isLoading == true}
                                                    >
                                                        {t('First_Responder.Save')}
                                                    </button>
                                                }
                                                {
                                                    this.props.predefinedTextData.isLoading ?
                                                        <img src={loader} width="30" alt="" /> : ''
                                                }
                                            </p>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div className=" forms-panel w3-last-form">
                    <div className="forms add-device">
                        <div className="form-three widget-shadow">
                            <div className=" panel-body-inputin">

                                <div className="w3l_search">
                                    {header}
                                </div>
                                <div className="devicestable">
                                    <br />

                                    <DataTable
                                        className="table"
                                        value={this.props.predefinedTextData.predefinedTextList}
                                        loading={this.props.predefinedTextData.isLoading}
                                        paginator={true} rows={10}
                                        globalFilter={this.state.globalFilter}
                                        rowClassName={this.rowClassName}
                                        emptyMessage={t('First_Responder.No records found')}
                                    >

                                        {/* <Column field="UserId" header="" className="noDisplay" sortable={true} />
                                        <Column field="DeviceId" header="" className="noDisplay" sortable={true} /> */}
                                        <Column field="Description" header={t('Alarm Setting.Predefined Text')} sortable={true} />
                                        {/* <Column field="CreatedDate" header={t('First_Responder.Answer')} sortable={true} />
                                        <Column field="UpdatedDate" header={t('First_Responder.First Name')} sortable={true} /> */}
                                        <Column sortable={true} headerClassName="hideheader" body={this.actionColumn} header={t('First_Responder.Action')} />
                                        {/* <Column header={t('First_Responder.Edit')} body={this.crudcheckbox}
                                        /> */}


                                    </DataTable>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withNamespaces()(withRouter(PredefinedTextComponent));

